<script>
import AppWell from '../../../../Shared/AppWell.vue';
import AppCard from '../../../../Shared/AppCard.vue';
import PageSection from '../../../../Shared/PageSection.vue';
import SubmitFormButton from '../../../Teacher/Activities/Subactivities/SubmitFormButton.vue';
import SurveyQuestionCheckboxes from './SurveyQuestionCheckboxes.vue';
import SurveyQuestionLinearScale from './SurveyQuestionLinearScale.vue';
import SurveyQuestionShortAnswer from './SurveyQuestionShortAnswer.vue';
import SurveyQuestionLongAnswer from './SurveyQuestionLongAnswer.vue';
import { IconExclamationCircle } from '@tabler/icons-vue';
import SurveyQuestionMultipleChoice from './SurveyQuestionMultipleChoice.vue';
import SurveyQuestionMultipleLongAnswer from './SurveyQuestionMultipleLongAnswer.vue';
import FormError from '@/components/Forms/FormError.vue';

export default {
    components: {
        FormError,
        AppWell,
        AppCard,
        PageSection,
        SubmitFormButton,
        IconExclamationCircle,
        checkboxes: SurveyQuestionCheckboxes,
        multiple_choice: SurveyQuestionMultipleChoice,
        linear_scale: SurveyQuestionLinearScale,
        short_answer: SurveyQuestionShortAnswer,
        long_answer: SurveyQuestionLongAnswer,
        multiple_long_answer: SurveyQuestionMultipleLongAnswer,
    },
    props: {
        survey: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            form: this.$inertia.form(this.survey),
        };
    },
    methods: {
        submit() {
            this.form.post(this.survey.url);
        },
    },
};
</script>

<template>
    <form :action="survey.url" method="post" @submit.prevent="submit" autocomplete="off">
        <div class="mt-1">
            <PageSection>
                <template v-slot:title>
                    {{ survey.title }}
                </template>
                <AppCard>
                    <p class="whitespace-pre-line p-2">{{ survey.description }}</p>
                </AppCard>
            </PageSection>
            <div class="mt-5 flex flex-col gap-8">
                <PageSection v-for="(section, sectionIndex) in form.sections" :key="section.id">
                    <template v-slot:title v-if="section.title">
                        {{ section.title }}
                    </template>
                    <template v-slot:subtitle v-if="section.subtitle">
                        {{ section.description }}
                    </template>
                    <div class="p-2">
                        <div class="mt-3 flex flex-col gap-4">
                            <div v-for="(question, questionIndex) in section.questions" :key="question.position">
                                <AppCard>
                                    <div class="p-1">
                                        <div>
                                            <span>{{ question.title }}</span>
                                            <span v-if="question.is_required" class="text-red-600"> *</span>
                                        </div>
                                        <div v-if="question.description" class="mt-1">
                                            <p class="text-gray-700">{{ question.description }}</p>
                                        </div>
                                        <div v-show="false">
                                            {{ question.type }}
                                        </div>
                                        <div class="mt-3">
                                            <component
                                                :is="question.type"
                                                :question="question"
                                                v-model="question.answer"
                                            />
                                        </div>
                                        <div>
                                            <FormError
                                                :value="
                                                    form.errors[
                                                        `sections.${sectionIndex}.questions.${questionIndex}.answer`
                                                    ]
                                                "
                                                class="mt-2"
                                            />
                                        </div>
                                        <div v-if="question.is_required" class="mt-1">
                                            <div
                                                class="text-red-600 flex gap-2 items-center"
                                                v-if="question.answer === question.default"
                                            >
                                                <IconExclamationCircle class="w-6 h-6" />
                                                <span class="text-sm">{{
                                                    $t('messages.this_question_is_required')
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </AppCard>
                            </div>
                        </div>
                    </div>
                </PageSection>
            </div>
        </div>
        <div class="flex justify-end mt-5">
            <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
        </div>
    </form>
</template>
